import {
    WF_ACTIVITY_REGISTRY,
    WfActivityRegistryEntry
} from '../wf/interface/wf-activity-registry';
import {
    DmDocumentUploadWfProcessStepActivityComponent
} from './component/protected-components/wf/dm-document-upload-wf-process-step-activity/dm-document-upload-wf-process-step-activity.component';

export const DM_WF_ACTIVITY_PROVIDER = [{
    provide: WF_ACTIVITY_REGISTRY,
    useValue: [
        ['document_upload_and_list', {mainComponent: DmDocumentUploadWfProcessStepActivityComponent}],
    ] as WfActivityRegistryEntry[],
    multi: true
}];
